var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CC4B81CE-6C1E-4C37-B9F5-4AF320097767@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.83333333,4.65482203 L1.42258898,0.244077682 C1.09715207,-0.0813592274 0.569514592,-0.0813592274 0.244077682,0.244077682 C-0.0813592274,0.569514592 -0.0813592274,1.09715207 0.244077682,1.42258898 L5.24407768,6.42258898 C5.56951459,6.74802589 6.09715207,6.74802589 6.42258898,6.42258898 L11.422589,1.42258898 C11.7480259,1.09715207 11.7480259,0.569514592 11.422589,0.244077682 C11.0971521,-0.0813592274 10.5695146,-0.0813592274 10.2440777,0.244077682 L5.83333333,4.65482203 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_Abonnement",
    transform: "translate(-808.000000, -461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12-Copy-2",
    transform: "translate(143.000000, 314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Composants-/-Mobile&Web-/-Input-Copy-5",
    transform: "translate(42.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones-/-Calendrier",
    transform: "translate(623.166667, 37.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#332E45",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown_arrow.ced3ab863b3b2661b952977ec30d3c60.svg";
export { ForwardRef as ReactComponent };